export interface CityData {
  name: string;
  lat: number;
  lng: number;
}

export interface LocationData {
  slug: string;
  name: string;
  state: string;
  region: string;
  description: string;
  highlights: string[];
  content: string[];
  isPrimary: boolean;
  lat: number;
  lng: number;
  cities: CityData[];
}

export const locations: LocationData[] = [
  {
    slug: "aubrey",
    name: "Aubrey",
    state: "TX",
    region: "Denton County",
    isPrimary: true,
    lat: 33.3043,
    lng: -96.9861,
    description:
      "R&R House Renovation LLC is based right here in Aubrey, TX. We handle insurance claims, storm and water damage restoration, roofing, concrete, and full home remodels across Denton County and the DFW metroplex.",
    highlights: [
      "Locally based in Aubrey, TX 76227",
      "Insurance claim specialists",
      "Roofing, concrete, remodels & restoration",
      "Open Monday – Saturday, 7 AM – 6 PM",
    ],
    content: [
      "Aubrey is home base. We live and work in the 76227 corridor, so when hail comes through Providence Village, Paloma Creek, Silverado, or Sandbrock Ranch, we are usually on roofs the same week — not three months later like the out-of-town storm chasers.",
      "Homeowners here call us for hail and wind claims, roof replacements, concrete driveways and patios, and full kitchen and bathroom remodels. Because Aubrey has so much newer construction alongside older farmhouse property, we work on everything from builder-grade tract homes needing upgrades to century-old houses needing real structural carpentry.",
      "Call (936) 371-1087 for a free inspection or estimate anywhere in Aubrey.",
    ],
    cities: [
      { name: "Providence Village", lat: 33.2379, lng: -96.9583 },
      { name: "Cross Roads", lat: 33.2032, lng: -96.9805 },
      { name: "Little Elm", lat: 33.1626, lng: -96.9375 },
      { name: "Pilot Point", lat: 33.3959, lng: -96.9603 },
      { name: "Krugerville", lat: 33.3487, lng: -96.9958 },
      { name: "Savannah", lat: 33.2212, lng: -96.9611 },
      { name: "Paloma Creek", lat: 33.1929, lng: -96.9459 },
      { name: "Oak Point", lat: 33.1848, lng: -96.9925 },
    ],
  },
  {
    slug: "denton",
    name: "Denton",
    state: "TX",
    region: "Denton County",
    isPrimary: false,
    lat: 33.2148,
    lng: -97.1331,
    description:
      "Home renovation, roofing, and insurance claim restoration in Denton, TX. Water, fire, and storm damage repair plus kitchen, bathroom, and whole-home remodels.",
    highlights: [
      "Hail & storm damage claim support",
      "Historic and student-rental property repair",
      "Kitchen & bathroom remodels",
      "Free written estimates",
    ],
    content: [
      "Denton mixes historic homes near the Square with newer subdivisions and a huge rental market around UNT and TWU. We work all three. Older properties usually need carpentry, rot repair, and drywall work before anything cosmetic; rentals need fast, durable turnarounds between tenants.",
      "Denton also sits in one of the most active hail corridors in Texas. If your roof took a hit, we inspect for free, document it properly, and meet your adjuster on site so the claim reflects the real scope of damage.",
      "Reach us at (936) 371-1087 for a free Denton estimate.",
    ],
    cities: [
      { name: "Corinth", lat: 33.154, lng: -97.0647 },
      { name: "Sanger", lat: 33.3637, lng: -97.1739 },
      { name: "Argyle", lat: 33.1212, lng: -97.1836 },
      { name: "Krum", lat: 33.2626, lng: -97.2378 },
      { name: "Lake Dallas", lat: 33.1212, lng: -97.0264 },
      { name: "Hickory Creek", lat: 33.1176, lng: -97.0392 },
      { name: "Ponder", lat: 33.1798, lng: -97.2872 },
      { name: "Lantana", lat: 33.0851, lng: -97.1231 },
    ],
  },
  {
    slug: "frisco",
    name: "Frisco",
    state: "TX",
    region: "Collin County",
    isPrimary: false,
    lat: 33.1507,
    lng: -96.8236,
    description:
      "Frisco, TX renovation and restoration contractor. Kitchen and bathroom remodels, flooring, painting, roofing, and insurance claim repairs.",
    highlights: [
      "High-end kitchen & bath remodels",
      "Roof replacement & hail claims",
      "Flooring, tile & custom carpentry",
      "One contractor for every trade",
    ],
    content: [
      "Frisco homes are newer, larger, and finished to a higher standard — which means the remodels here are about upgrading, not just repairing. We do a lot of kitchen island rebuilds, quartz countertop replacements, tile shower conversions, and luxury vinyl plank throughout.",
      "We also handle the less glamorous work: hail claims on roofs, water damage from failed supply lines and water heaters, and drywall and paint restoration afterward. Same crew, start to finish, so nothing falls through the cracks between trades.",
      "Call (936) 371-1087 for a free Frisco consultation.",
    ],
    cities: [
      { name: "Prosper", lat: 33.2362, lng: -96.8011 },
      { name: "Little Elm", lat: 33.1626, lng: -96.9375 },
      { name: "The Colony", lat: 33.0806, lng: -96.8861 },
      { name: "Plano", lat: 33.0198, lng: -96.6989 },
      { name: "Celina", lat: 33.3248, lng: -96.7847 },
      { name: "McKinney", lat: 33.1972, lng: -96.6398 },
      { name: "Allen", lat: 33.1032, lng: -96.6706 },
      { name: "Melissa", lat: 33.2857, lng: -96.5728 },
    ],
  },
  {
    slug: "dallas",
    name: "Dallas",
    state: "TX",
    region: "Dallas County",
    isPrimary: false,
    lat: 32.7767,
    lng: -96.797,
    description:
      "Dallas home renovation and damage restoration. Insurance claims, roofing, concrete, painting, flooring, and complete kitchen and bathroom remodels.",
    highlights: [
      "Insurance claim specialists",
      "Water, fire & storm restoration",
      "Whole-home renovations",
      "Free inspections across Dallas",
    ],
    content: [
      "Dallas has everything from 1920s bungalows in Oak Cliff to high-rise condos downtown to sprawling new builds on the north side. Every one of them ages differently, and we scope each job for what the property actually needs instead of running a one-size-fits-all package.",
      "Our busiest Dallas work is insurance restoration — hail-damaged roofs, water losses from burst pipes during freezes, and fire and smoke damage rebuilds. We document the loss, handle the carrier, and then complete the repairs ourselves.",
      "Get your free Dallas estimate at (936) 371-1087.",
    ],
    cities: [
      { name: "Oak Cliff", lat: 32.7357, lng: -96.8433 },
      { name: "Lake Highlands", lat: 32.8709, lng: -96.7183 },
      { name: "Preston Hollow", lat: 32.8757, lng: -96.8069 },
      { name: "Richardson", lat: 32.9483, lng: -96.7299 },
      { name: "Addison", lat: 32.9618, lng: -96.8292 },
      { name: "Farmers Branch", lat: 32.9268, lng: -96.8961 },
      { name: "Highland Park", lat: 32.8335, lng: -96.8016 },
      { name: "Lakewood", lat: 32.8195, lng: -96.7519 },
    ],
  },
  {
    slug: "fort-worth",
    name: "Fort Worth",
    state: "TX",
    region: "Tarrant County",
    isPrimary: false,
    lat: 32.7555,
    lng: -97.3308,
    description:
      "Fort Worth renovation contractor. Roofing, concrete, carpentry, painting, and full home remodels — plus insurance claim restoration for storm and water damage.",
    highlights: [
      "Roof replacement & hail claims",
      "Concrete driveways & patios",
      "Full home & kitchen renovations",
      "Free written estimates",
    ],
    content: [
      "Fort Worth and the surrounding Tarrant County suburbs take a beating from spring storms. We handle roof replacements, fence and fascia repair, and the interior drywall and paint work that follows a leak.",
      "Beyond storm work, Fort Worth homeowners bring us older houses that need real carpentry — rotted fascia and soffit, sagging floors, wall removals to open up cramped 1960s floor plans — plus concrete work that has to survive this area's shifting clay soil.",
      "Call (936) 371-1087 to schedule a free Fort Worth estimate.",
    ],
    cities: [
      { name: "Keller", lat: 32.9346, lng: -97.2289 },
      { name: "Haltom City", lat: 32.7996, lng: -97.269 },
      { name: "Saginaw", lat: 32.8601, lng: -97.3639 },
      { name: "North Richland Hills", lat: 32.8342, lng: -97.2289 },
      { name: "Watauga", lat: 32.8579, lng: -97.2547 },
      { name: "Hurst", lat: 32.8235, lng: -97.1706 },
      { name: "Bedford", lat: 32.844, lng: -97.1431 },
      { name: "Blue Mound", lat: 32.8543, lng: -97.3392 },
    ],
  },
  {
    slug: "arlington",
    name: "Arlington",
    state: "TX",
    region: "Tarrant County",
    isPrimary: false,
    lat: 32.7357,
    lng: -97.1081,
    description:
      "Arlington, TX home renovation and restoration. Storm and water damage repair, roofing, flooring, painting, and kitchen and bathroom remodels.",
    highlights: [
      "Water & storm damage restoration",
      "Roofing & exterior repair",
      "Bathroom & kitchen remodels",
      "Insurance claim documentation",
    ],
    content: [
      "Arlington's housing stock leans heavily toward 1970s–1990s construction, which means original bathrooms, dated kitchens, and roofs that are on their second or third replacement. Those are exactly the projects we do best.",
      "We handle full gut bathroom remodels with properly waterproofed tile showers, kitchen rebuilds with new cabinets and quartz counters, and the flooring and paint that tie the rest of the house together.",
      "Free Arlington estimates at (936) 371-1087.",
    ],
    cities: [
      { name: "Pantego", lat: 32.7143, lng: -97.1561 },
      { name: "Kennedale", lat: 32.6468, lng: -97.2258 },
      { name: "Grand Prairie", lat: 32.7459, lng: -96.9978 },
      { name: "Euless", lat: 32.8371, lng: -97.082 },
      { name: "Dalworthington Gardens", lat: 32.7015, lng: -97.1544 },
      { name: "Hurst", lat: 32.8235, lng: -97.1706 },
      { name: "Bedford", lat: 32.844, lng: -97.1431 },
      { name: "Irving", lat: 32.814, lng: -96.9489 },
    ],
  },
  {
    slug: "grand-prairie",
    name: "Grand Prairie",
    state: "TX",
    region: "Dallas County",
    isPrimary: false,
    lat: 32.7459,
    lng: -96.9978,
    description:
      "Grand Prairie renovation and repair contractor. Concrete, roofing, carpentry, flooring, and complete interior remodels with insurance claim support.",
    highlights: [
      "Concrete driveways, patios & slabs",
      "Roof repair & replacement",
      "Interior & exterior painting",
      "Bilingual service — English & Spanish",
    ],
    content: [
      "Grand Prairie sits right between Dallas and Fort Worth, and we work both ends of it. Concrete is a big part of our work here — driveways, patios, and walkways that have cracked and heaved with the clay soil underneath.",
      "We also take on interior renovations: flooring replacement, kitchen and bath updates, drywall and texture repair, and full interior repaints. Our team is bilingual, so communication is never the hard part of your project.",
      "Call (936) 371-1087 for free Grand Prairie pricing.",
    ],
    cities: [
      { name: "Cedar Hill", lat: 32.5885, lng: -96.9561 },
      { name: "Duncanville", lat: 32.6518, lng: -96.9083 },
      { name: "Irving", lat: 32.814, lng: -96.9489 },
      { name: "DeSoto", lat: 32.5899, lng: -96.857 },
      { name: "Coppell", lat: 32.9546, lng: -97.015 },
      { name: "Euless", lat: 32.8371, lng: -97.082 },
      { name: "Oak Cliff", lat: 32.7357, lng: -96.8433 },
      { name: "Arlington", lat: 32.7357, lng: -97.1081 },
    ],
  },
  {
    slug: "lewisville",
    name: "Lewisville",
    state: "TX",
    region: "Denton County",
    isPrimary: false,
    lat: 33.0462,
    lng: -96.9942,
    description:
      "Lewisville, TX renovation services. Kitchen and bathroom remodels, flooring, painting, roofing, and water and storm damage restoration.",
    highlights: [
      "Kitchen & bathroom renovations",
      "Tile, hardwood, laminate & vinyl flooring",
      "Roofing & hail claim inspections",
      "Fast response on water damage",
    ],
    content: [
      "Lewisville is a short drive from our Aubrey shop, so we are on jobs here constantly. Lake-adjacent homes deal with more moisture issues than most of DFW, which means water damage, subfloor rot, and mold-prone bathrooms come up often.",
      "We handle those the right way: find the source, dry the structure properly, replace what is compromised, then rebuild with materials that hold up. And when it is time for the fun part, we do the kitchen and bath remodels too.",
      "Book your free Lewisville estimate at (936) 371-1087.",
    ],
    cities: [
      { name: "Flower Mound", lat: 33.0146, lng: -97.097 },
      { name: "Highland Village", lat: 33.0918, lng: -97.0467 },
      { name: "Carrollton", lat: 32.9537, lng: -96.8903 },
      { name: "Coppell", lat: 32.9546, lng: -97.015 },
      { name: "The Colony", lat: 33.0806, lng: -96.8861 },
      { name: "Castle Hills", lat: 33.0107, lng: -96.8877 },
      { name: "Double Oak", lat: 33.0662, lng: -97.1092 },
      { name: "Hebron", lat: 33.0043, lng: -96.9236 },
    ],
  },
  {
    slug: "garland",
    name: "Garland",
    state: "TX",
    region: "Dallas County",
    isPrimary: false,
    lat: 32.9126,
    lng: -96.6389,
    description:
      "Garland, TX home renovation and restoration. Roofing, carpentry, painting, flooring, and full remodels backed by insurance claim expertise.",
    highlights: [
      "Storm & hail damage restoration",
      "Carpentry & structural repair",
      "Full interior remodels",
      "Free, no-pressure inspections",
    ],
    content: [
      "Garland's older neighborhoods have solid bones but a lot of deferred maintenance — original single-pane windows, rotted trim, dated kitchens, and roofs that have outlived their warranty by a decade.",
      "We take those houses on as complete projects: carpentry and structural repair first, then flooring, paint, and the kitchen and bathroom work that makes the place feel new. Storm claims included when the damage qualifies.",
      "Call (936) 371-1087 for a free Garland estimate.",
    ],
    cities: [
      { name: "Rowlett", lat: 32.9029, lng: -96.5639 },
      { name: "Sachse", lat: 32.9762, lng: -96.5952 },
      { name: "Mesquite", lat: 32.767, lng: -96.5992 },
      { name: "Richardson", lat: 32.9483, lng: -96.7299 },
      { name: "Wylie", lat: 33.0151, lng: -96.5389 },
      { name: "Murphy", lat: 33.0151, lng: -96.6131 },
      { name: "Rockwall", lat: 32.9312, lng: -96.4597 },
      { name: "Sunnyvale", lat: 32.7973, lng: -96.5539 },
    ],
  },
  {
    slug: "grapevine",
    name: "Grapevine",
    state: "TX",
    region: "Tarrant County",
    isPrimary: false,
    lat: 32.9343,
    lng: -97.0781,
    description:
      "Grapevine renovation contractor. Custom carpentry, kitchen and bathroom remodels, flooring, painting, roofing, and storm damage restoration.",
    highlights: [
      "Custom carpentry & built-ins",
      "High-end kitchen & bath remodels",
      "Roofing & exterior restoration",
      "Detail-focused finish work",
    ],
    content: [
      "Grapevine homeowners tend to care about finish detail, and that suits us. Custom built-ins, crown molding, wainscoting, tile showers with planned layouts, and cabinetry that actually fits the wall it is on.",
      "We also handle the practical side — roof replacements after hail, exterior repaints rated for Texas sun, and concrete patios and walkways that hold up to freeze-thaw cycles.",
      "Reach us at (936) 371-1087 for a free Grapevine consultation.",
    ],
    cities: [
      { name: "Southlake", lat: 32.9412, lng: -97.1342 },
      { name: "Colleyville", lat: 32.8807, lng: -97.155 },
      { name: "Euless", lat: 32.8371, lng: -97.082 },
      { name: "Roanoke", lat: 33.0043, lng: -97.2258 },
      { name: "Trophy Club", lat: 33.0034, lng: -97.1842 },
      { name: "Westlake", lat: 32.9912, lng: -97.1964 },
      { name: "Bedford", lat: 32.844, lng: -97.1431 },
      { name: "Hurst", lat: 32.8235, lng: -97.1706 },
    ],
  },
];

export const primaryLocation = locations.find((l) => l.isPrimary) ?? locations[0];
